import React from 'react';
import './quote.css';

function Quote() {
  return (
    <div>
      <p className="quote">
        Mathmatics is not about numbers, equations, computations,
        algorithums: it is about understanding. Willium Paul Thurston
      </p>
    </div>
  );
}

export default Quote;
